import PaysonicLogo from "@assets/logos/PaySonic.svg";
import TyltLogo from "@assets/logos/TyltLogo.svg";
import useBrandConfig from "../../../utils/hooks/useBrandConfig";

interface LogoImageComponentProps {
  className?: string;
}

const LogoImageComponent: React.FC<LogoImageComponentProps> = ({
  className,
}) => {
  const { isPaysonic } = useBrandConfig();
  return (
    <img
      src={isPaysonic ? PaysonicLogo : TyltLogo}
      alt=""
      className={className ? `${className}` : ""}
    />
  );
};

export default LogoImageComponent;
